var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlowoutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#blowout-icon_svg__clip0_12493_82581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 30L24 27 7.5 30h-3l3-9h13.14L24 22.86 27.36 21H40.5l3 9h-3z",
    fill: "#597EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 30v18h-33V30L24 27l16.5 3zM31.68 16.68L27.36 21 24 22.86 20.64 21l-4.32-4.32a4.472 4.472 0 010-6.36 4.472 4.472 0 016.36 0L24 11.64l1.32-1.32a4.472 4.472 0 016.36 0 4.472 4.472 0 010 6.36zM12 1.757l.879-.878A3 3 0 0117.12 5.12L12 10.243 6.879 5.12A3 3 0 1111.12.88l.879.878zM36 1.757l.879-.878A3 3 0 0141.12 5.12L36 10.243 30.879 5.12A3 3 0 1135.12.88l.879.878z",
    fill: "#ADC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 42h12v3h-12v-3zM31.5 36h6v3h-6v-3z",
    fill: "#597EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 27h33v3h-33v-3zM27.36 21L24 24.36 20.64 21h6.72z",
    fill: "#1D39C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "blowout-icon_svg__clip0_12493_82581"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/blowout-icon.b8c0a66e5707921c158f17bbb461c5b2.svg";
export { SvgBlowoutIcon as ReactComponent };